export function assetURL(url:string) {
	const base:string = _config.getAssetURL();
	
	if(url.substr(0, 1) != "/" && base)
		url = `/${url}`;
		
	return `${base}${url}`;
}

/**
	* Get flag asset icon name
	* 
	* @returns {string} The asset icon name
*/
export function getFlagAssetName(countryCode:string) {
	let countryId:string = countryCode.split("-")[1].toLowerCase();
	
	switch(countryCode) {
		case 'cy-GB':
			countryId = 'wales';
			break;
	}
	
	return countryId;
}